// extracted by mini-css-extract-plugin
export default {"main":"MenuMobile_main__tnkOx","basket":"MenuMobile_basket__5qHFE","basket__amountItems":"MenuMobile_basket__amountItems__sarED","button":"MenuMobile_button__h62nu"};